import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Container,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Link } from "react-router-dom";
import { Group } from "../lib/types";
import { groupAPI } from "../services/api";
import { GroupsList, GroupCardSkeleton } from "../components/groups";

const GroupsPage: React.FC = () => {
  const [groups, setGroups] = useState<Group[]>([]);
  const [loading, setLoading] = useState(true);

  const loadGroups = useCallback(async () => {
    try {
      setLoading(true);
      const groupsData = await groupAPI.list();
      setGroups(groupsData);
    } catch (error) {
      console.error("Failed to load groups:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadGroups();
  }, [loadGroups]);

  useEffect(() => {
    const handleMembershipUpdated = () => {
      loadGroups();
    };
    window.addEventListener(
      "groups:membership-updated",
      handleMembershipUpdated
    );
    return () => {
      window.removeEventListener(
        "groups:membership-updated",
        handleMembershipUpdated
      );
    };
  }, [loadGroups]);

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Stack spacing={3}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          alignItems={{ sm: "center" }}
          justifyContent="space-between"
        >
          <Box>
            <Typography variant="h4" fontWeight={800} gutterBottom>
              Groups
            </Typography>
            <Typography color="text.secondary">
              Manage shared access across family and business teams.
            </Typography>
          </Box>
          <Tooltip title="New group">
            <IconButton
              component={Link}
              to="/groups/new"
              color="primary"
              onClick={() => console.log("Navigating to create group")}
            >
              <AddCircleOutlineIcon />
            </IconButton>
          </Tooltip>
        </Stack>

        {loading ? (
          <Grid container spacing={3}>
            {[1, 2, 3].map((i) => (
              <Grid size={{ xs: 12, md: 6, lg: 4 }} key={i}>
                <GroupCardSkeleton />
              </Grid>
            ))}
          </Grid>
        ) : (
          <GroupsList groups={groups} />
        )}
      </Stack>
    </Container>
  );
};

export default GroupsPage;
